module.exports = __webpack_public_path__ + "img/Resume-pic3.6ad88872.png";